import { i18n } from '../../i18n';
import { request } from 'beans-admin-plugin';



export const filterColumnsHash = {

}

export const columnsHash = {
  id: {
    label: i18n.t('adminUsersRole.id'),
    width: 80,
  },
  admin_user_id: {
    label: i18n.t('adminUsersRole.adminUser'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.admin_user) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'admin_users.show', params: { id: row.admin_user_id } }}>{row.admin_user.name}</bean-link>
    },
  },
  application_id: {
    label: i18n.t('adminUsersRole.application'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.application) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'applications.show', params: { id: row.application_id } }}>{row.application.name}</bean-link>
    },
  },
  role_id: {
    label: i18n.t('adminUsersRole.role'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.role) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'roles.show', params: { id: row.role_id } }}>{row.role.name}</bean-link>
    },
  },
  created_at: {
    label: i18n.t('adminUsersRole.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('adminUsersRole.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
}

export const formColumnsHash = {
  role_id: {
    label: i18n.t('adminUsersRole.role'),
    renderCell: {
      required: true,
      component: 'select',
      props: {
        xRemotePreload: async () => {
          const { data } = await request.get('/roles', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { name_cont: keyword };
          const { data } = await request.get('/roles', { params });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  },
}
